import { useCallback, useEffect, useRef } from "react";
import { useToast } from "./ToastContext";

/** Oczekuje na decyzję i anuluje ją, gdy formularz lub jego zasób przestaje istnieć. */
export default function useToastConfirmation(scope = null) {
  const { requestConfirmation, dismiss } = useToast();
  const pending = useRef(null);
  const cancel = useCallback(() => {
    if (pending.current) dismiss(pending.current.id);
    pending.current = null;
  }, [dismiss]);
  useEffect(() => cancel, [scope, cancel]);
  const confirm = useCallback(
    (message, options) => {
      if (pending.current) return pending.current.result;
      const request = requestConfirmation(message, options);
      pending.current = request;
      request.result.finally(() => {
        if (pending.current === request) pending.current = null;
      });
      return request.result;
    },
    [requestConfirmation],
  );
  return { confirm, cancel };
}
